import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { SettingService } from '../../../../account/services/settings/setting.service';

/**
 * Formats every ngbDatepicker input in the app using the airline's chosen date
 * format (Settings -> Preferences).
 *
 * Provided once at the root so a component cannot silently miss out: without a
 * provider ng-bootstrap falls back to its own ISO formatter and the input shows
 * yyyy-mm-dd, which is how four datepickers ended up ignoring the preference.
 *
 * The concrete formatter is resolved per call rather than at construction: this
 * is a root singleton created before the user's company settings have loaded,
 * and the preference can also be changed mid-session.
 */
@Injectable({ providedIn: 'root' })
export class UserDateParserFormatter extends NgbDateParserFormatter {
    private cachedFormat: string | null;
    private cachedFormatter: NgbDateParserFormatter | null = null;

    constructor(private settingService: SettingService) {
        super();
    }

    public parse(value: string): NgbDateStruct | null {
        return this.formatter().parse(value);
    }

    public format(date: NgbDateStruct | null): string {
        return this.formatter().format(date);
    }

    private formatter(): NgbDateParserFormatter {
        const format = this.settingService.getCompanyDateFormat();
        if (!this.cachedFormatter || format !== this.cachedFormat) {
            this.cachedFormat = format;
            this.cachedFormatter = this.settingService.getCompanyDateFormatter();
        }
        return this.cachedFormatter;
    }
}
